module.exports = __webpack_public_path__ + "static/img/waitting.9c93eb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/waitting.png
// module id = mkkW
// module chunks = 1